import { useState, useContext, useRef } from 'react';
import Util from 'lib/util.js';
import Storage from 'services/storage2';
import Http from 'services/http2';
import User from 'services/user2';
import EnumService from 'services/enum2';
import CompanyService from 'services/company2';
/**
 * 静态列表页自定义Hooks
 *
 * @param props
 * @param config
 * @returns
 */
export default function useStaticList(props: any, config: any) {
  const [companyCode, setCompanyCode] = useState<string | null>(null);
  const [inited, setInited] = useState(false); //初始化顶部菜单/搜索栏
  const [error, setError] = useState<any>(null);
  const [dataError, setDataError] = useState<any>(null);

  const [listPage, setListPage] = useState<any[]>([]); // 列表分页数据
  const [arrSearchField, setArrSearchField] = useState([]); //搜索字段
  const [arrNumberField, setArrNumberField] = useState([]); // 数字字段，搜索排序时用

  // const [pageNum, setPageNum] = useState(1);
  const [total, setTotal] = useState(0);
  const [updateTs, setUpdateTs] = useState(0);
  // 以下状态需要记忆，为方便写缓存时判断是否初始值，故使用 undefined 初始化
  //const [searchKey, setSearchKey] = useState<string | undefined>(undefined);
  const [currentTab, setCurrentTab] = useState<number | undefined>(undefined); //当前页签
  const [listField, setListField] = useState<string>('list'); //当前列表参数

  let objHistoryState: any = Storage.getItem('historyState') || {};
  let urlHashKey: string = Util.getHashKey(props.match.url);
  let historyState: any = { searchKey: '' };
  let isPurchase = props.type ? props.type.indexOf('purchase') !== -1 : true; // 从路由读取是否采购方，在采购方和供应方共用列表时必传。默认true
  let searchQueries = {}; //列表请求参数
  let pageResolveLoading: Function = () => {}; //引用InfiniteLoader中resolveLoading方法，用于重置列表加载状态
  let init: Function = () => {};
  let list: any[] = []; // 原始列表数据
  let listFilter: any[] = []; // 搜索过滤列表数据

  let searchKey: string = '';
  let pageNum: number = 0;
  let getData: Function = () => {};
  let filter: Function = () => {};
  let search: Function = () => {};
  let listTransform: Function = () => {};
  let saveHistorySatate: Function = () => {};

  //创建实例，用于储存非状态可变值
  let instant = useRef({
    searchKey,
    pageNum,
    list,
    listFilter,
    isPurchase,
    objHistoryState,
    urlHashKey,
    historyState,
    pageResolveLoading,
    init,
    filter,
    getData,
    search,
    searchQueries,
    listTransform,
    saveHistorySatate
  });
  let self = instant.current;

  self.init = function () {
    //获取页面历史状态，用于详情页返回列表（页面页签等）
    // self.historyState = self.objHistoryState[self.urlHashKey] || {};
    // //setSearchKey(self.historyState.searchKey);

    // if (self.historyState.currentTab > 0) {
    //   handleTab(self.historyState.currentTab);
    // } else {
    //   handleTab(0);
    // }

    // if (self.historyState.searchQueries) {
    //   self.searchQueries = self.historyState.searchQueries;
    // }

    User.init().then(response => {
      if (response.success) {
        setInited(true);
        setCompanyCode(User.getCompanyCode());
        self.getData();
      } else {
        setError({
          type: 'warn',
          title: response.errorMsg
        });
      }
    });
  };

  // 获取原始数据
  self.getData = async function () {
    if (!companyCode) {
      return;
    }
    let postbody = {
      apiPath: config.apiPath,
      ascOrDesc: 'desc',
      companyCode,
      ...self.searchQueries,
      orderProperty: config.orderProperty,
      pageNum: 1,
      pageSize: 100
    };

    let arrPromise = [Http.post('/api/cloudCenter', postbody)];
    if (Array.isArray(config.arrEnumField)) {
      config.arrEnumField.forEach((item: any) => {
        arrPromise.push(EnumService.getList(item.mainKey));
      });
    }

    setDataError(null);

    await Promise.all(arrPromise).then(async arrResponse => {
      let response = arrResponse[0];

      if (response.success) {
        let arr: any[] = listField ? response.data[listField] : response.data;

        for (let item of arr) {
          //枚举转换
          if (
            Array.isArray(config.arrEnumField) &&
            config.arrEnumField.length > 0
          ) {
            for (let conf of config.arrEnumField) {
              await EnumService.getValue(conf.mainKey, item[conf.subKey]).then(
                value => {
                  item[conf.value] = value;
                }
              );
            }
          }

          //小数位获取
          let dpCompanyCode =
            props.type === 'customerOrder' ? item.customerCode : companyCode;
          await CompanyService.getDecimalPlaceByCodes(dpCompanyCode).then(
            (rs: any) => {
              for (let code in rs) {
                item[code] = rs[code];
              }
            }
          );
        }
        self.list = arr;

        self.search();
      } else {
        setDataError({
          type: 'warn',
          title: response.errorMsg
        });
      }
    });
  };

  // 默认过滤方法，可根据搜索条件覆盖
  self.filter = async function () {
    self.listFilter = self.list.map(item => item);
  };

  self.search = async function (isReset?) {
    await self.filter();
    self.listFilter = listSearch(
      self.listFilter,
      self.searchKey,
      arrSearchField
    );
    await self.listTransform(self.listFilter);
    self.pageNum += 1;
    genListPage(isReset);
    self.pageResolveLoading();
    self.saveHistorySatate();
    forceUpdate();
  };

  // 列表搜索过滤
  function listSearch(arr, sKey, arrField, strict: boolean = false) {
    return arr.filter(item => {
      if (typeof sKey !== 'string' || sKey === '') {
        return true;
      } else {
        return arrField.some(field => {
          if (typeof item[field] !== 'string') {
            return false;
          }
          let key = sKey.trim().toLowerCase();
          let value = item[field].toLowerCase();
          if (key.substr(-1) === '*') {
            //通配符搜索，比如关键字"05*"，过滤以05开头的内容
            let val = '';
            key.split('*').some(str => {
              if (str) {
                val = str;
              }
              return str;
            });
            let reg = new RegExp('^' + val + '.*$');
            return reg.test(value);
          } else if (strict === true) {
            //严格模式
            return value === key;
          } else {
            return value.indexOf(key) !== -1;
          }
        });
      }
    });
  }

  // 生成前端分页数据
  function genListPage(isReset?) {
    if (isReset) {
      handleReset();
    }
    let totalNum = self.listFilter.length;
    let begin = (self.pageNum - 1) * 10;
    let end = Math.min(self.pageNum * 10, totalNum);
    let arr = self.listFilter.slice(begin, end);
    if (isReset) {
      setListPage(arr);
    } else {
      setListPage(listPage.concat(arr));
    }
    setTotal(totalNum);
  }

  /**
   * 保存搜索历史
   *
   */
  self.saveHistorySatate = function () {
    if (config.needSessionStorage) {
      self.historyState.searchQueries = self.searchQueries;
      self.objHistoryState[self.urlHashKey] = self.historyState;
      Storage.setItem('historyState', self.objHistoryState);
    }
  };

  //记忆搜索key
  // useEffect(() => {
  //   if (searchKey !== undefined) {
  //     self.historyState.searchKey = searchKey;
  //     self.objHistoryState[self.urlHashKey] = self.historyState;
  //     Storage.setItem('historyState', self.objHistoryState);
  //   }
  // }, [searchKey, self]);

  //记忆页签
  // useEffect(() => {
  //   if (currentTab !== undefined) {
  //     self.historyState.currentTab = currentTab;
  //     self.objHistoryState[self.urlHashKey] = self.historyState;
  //     Storage.setItem('historyState', self.objHistoryState);
  //   }
  // }, [currentTab, self]);

  //强制重新渲染
  function forceUpdate() {
    setUpdateTs(Date.now());
  }

  //搜索关键字改变
  function handleChange(text: string, e: any) {
    e.preventDefault();
    self.searchKey = text;
    self.search(true);
  }

  //清除搜索关键字
  function handleClear() {
    if (self.searchKey === '') {
      return;
    }
    self.searchKey = '';
    self.search(true);
  }

  //切换页签
  function handleTab(index: number) {
    handleReset();
    setCurrentTab(index);
  }

  //重置列表
  function handleReset() {
    setListPage([]);
    self.listFilter = [];
    self.pageNum = 0;
    self.pageResolveLoading();
  }

  return {
    companyCode,
    setCompanyCode,
    inited,
    setInited,
    error,
    setError,
    dataError,
    setDataError,
    currentTab,
    setCurrentTab,
    total,
    listPage,
    forceUpdate,
    handleChange,
    handleClear,
    handleTab,
    handleReset,
    updateTs,
    setUpdateTs,
    setListField,
    setArrSearchField,
    self
  };
}
